/**
 * Border style tokens.
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const borderStyles = Object.freeze({
    none: 'none',
    solid: 'solid',
    dashed: 'dashed',
    dotted: 'dotted',
    double: 'double',
});
const BORDER_STYLE_TOKEN_SET = new Set(Object.keys(borderStyles));
export function isBorderStyleToken(value) {
    return BORDER_STYLE_TOKEN_SET.has(value);
}
export const BORDER_STYLE_TOKEN_KEYS = Object.freeze(Object.keys(borderStyles).sort());
//# sourceMappingURL=border-styles.js.map